import { PlanLimits, formatMoney } from "../../../../../constants/subscription";

/**
 * One line saying what a plan includes — "1 specialist · 30 bookings/month".
 *
 * A capped plan states its ceiling: the free tier is one specialist and refuses
 * a second. The paid plans are not capped but priced, so what stops being free
 * there is the seat count, and that is what they state. "Unlimited" is left for
 * a plan that is neither, which no plan on sale is today.
 */
export const planLimitSummary = (plan, quotes, t) => {
  const limits = PlanLimits[plan];
  if (!limits) return "";
  const seats = quotes?.[plan];
  const staff =
    limits.maxStaff != null
      ? t("Dashboard.Plan.staffMax", { count: limits.maxStaff })
      : seats?.extraSeatPrice != null
        ? t("Dashboard.Plan.seatsSummary", {
            count: seats.includedSeats,
            price: formatMoney(seats.extraSeatPrice, seats.currency),
          })
        : t("Dashboard.Plan.unlimitedStaff");
  const bookings =
    limits.maxBookingsPerMonth == null
      ? t("Dashboard.Plan.unlimitedBookings")
      : t("Dashboard.Plan.bookingsCount", {
          count: limits.maxBookingsPerMonth,
        });
  return `${staff} · ${bookings}`;
};
